// extracted by mini-css-extract-plugin
module.exports = {"maxSiteWidth":"75rem","marketingHeader":"_1Ytrfsq1BiAAohhO7O9we"};